
import React from 'react'

function Admins() {
  return (
    <div>
        
    </div>
  )
}

export default Admins